<template>
  <div class="pa-5">
    <div v-if="!loading">
      <div v-if="hasInvoices">
        <div v-for="invoice in invoices" :key="invoice.month">
          <p class="title">{{ monthName(invoice) }}</p>

          <HostInvoicesFortnight
            @sendInvoiceData="sendInvoiceData"
            :invoices="transformInToArray(invoice.first_half)"
            :title="$t('hausefulInvoices.firstHalf')"
          />

          <HostInvoicesFortnight
            @sendInvoiceData="sendInvoiceData"
            :invoices="transformInToArray(invoice.second_half)"
            :title="$t('hausefulInvoices.secondHalf')"
          />
        </div>
      </div>
      <EmptyState v-else />
    </div>

    <h-loading v-else />
  </div>
</template>

<script>
import EmptyState from '@/components/app/EmptyState.vue';
import HostInvoicesFortnight from './fragments/HostInvoicesFortnight'

export default {
  name: 'HostPendingInvoices',

  components: {
    HostInvoicesFortnight,
    EmptyState,
  },

  props: {
    invoices: {
      type: Array,
      required: false,
    },

    loading: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    hasInvoices() {
      return this.invoices?.length > 0
    },
  },

  methods: {
    monthName(invoice) {
      return invoice?.month_name ?? '---'
    },

    transformInToArray(invoices) {
      if (!invoices) return []
      return Object.values(invoices)
    },

    sendInvoiceData(sendInvoiceData) {
      this.$emit('sendInvoiceData', sendInvoiceData)
    },
  },
}
</script>

<style>
.content {
  padding: 0 !important;
  background-color: #f5f5f5;
}

.rounded-b-lg {
  margin-top: -1px;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>
